import * as yup from "yup";

export const AddSignatureFormSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
  role: yup.string().required().label("Role"),
});
